import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_DASHBOARD_NEW_ASSETS = defineFcm('starter_dashboard_new_assets')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				locales: { type: 'array', shape: { type: 'enum', values: getLocales() } },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
